import React from 'react';
export const InformationLiner24 = () => /*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.125 7.12506C13.125 7.74638 12.6213 8.25006 12 8.25006C11.3787 8.25006 10.875 7.74638 10.875 7.12506C10.875 6.50374 11.3787 6.00006 12 6.00006C12.6213 6.00006 13.125 6.50374 13.125 7.12506Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 10.2501C12.4142 10.2501 12.75 10.5858 12.75 11.0001V17.7501C12.75 18.1643 12.4142 18.5001 12 18.5001C11.5858 18.5001 11.25 18.1643 11.25 17.7501V11.0001C11.25 10.5858 11.5858 10.2501 12 10.2501Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9996 0.225098C5.49646 0.225098 0.224609 5.49694 0.224609 12.0001C0.224609 18.5033 5.49646 23.7751 11.9996 23.7751C18.5028 23.7751 23.7746 18.5033 23.7746 12.0001C23.7746 5.49694 18.5028 0.225098 11.9996 0.225098ZM1.72461 12.0001C1.72461 6.32537 6.32488 1.7251 11.9996 1.7251C17.6743 1.7251 22.2746 6.32537 22.2746 12.0001C22.2746 17.6748 17.6743 22.2751 11.9996 22.2751C6.32488 22.2751 1.72461 17.6748 1.72461 12.0001Z",
  fill: "currentColor"
}));